import { render, staticRenderFns } from "./AbsenceRegistration.vue?vue&type=template&id=298e5fde&scoped=true&"
import script from "./AbsenceRegistration.vue?vue&type=script&lang=js&"
export * from "./AbsenceRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceRegistration.vue?vue&type=style&index=0&id=298e5fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298e5fde",
  null
  
)

export default component.exports